export const FILE_TYPE_PDF = "PDF";
export const FILE_TYPE_XML = "XML";
export const FILE_TYPE_IMG = "IMG";

export const FILE_TYPE_PNG_ID = "png";
export const FILE_TYPE_JPG_ID = "jpg";
export const FILE_TYPE_PDF_ID = "pdf";
export const FILE_TYPE_JSON_ID = "json";
export const FILE_TYPE_XML_ID = "xml";
export const FILE_TYPE_CSV_ID = "csv";

export const SUPPORTED_FILE_TYPES = [
  {
    id: FILE_TYPE_PDF_ID,
    name: "PDF",
    mimeTypes: ["application/pdf"],
    extensions: [".pdf"],
    icon: "MdPictureAsPdf",
    isImage: false,
  },
  {
    id: FILE_TYPE_JPG_ID,
    name: "JPG/JPEG",
    mimeTypes: ["image/jpeg"],
    extensions: [".jpg", ".jpeg"],
    icon: "MdImage",
    isImage: true,
  },
  {
    id: FILE_TYPE_PNG_ID,
    name: "PNG",
    mimeTypes: ["image/png"],
    extensions: [".png"],
    icon: "MdImage",
    isImage: true,
  },
  {
    id: FILE_TYPE_CSV_ID,
    name: "CSV",
    mimeTypes: ["text/csv"],
    extensions: [".csv"],
    icon: "MdDescription",
    isImage: false,
  },
  {
    id: FILE_TYPE_XML_ID,
    name: "XML",
    mimeTypes: ["text/xml", "application/xml"],
    extensions: [".xml"],
    icon: "MdCode",
    isImage: false,
  },
  {
    id: FILE_TYPE_JSON_ID,
    name: "JSON",
    mimeTypes: ["application/json"],
    extensions: [".json"],
    icon: "MdDataObject",
    isImage: false,
  },
];

export const FILE_TYPES_DOCUMENTS = [
  FILE_TYPE_PDF_ID,
  FILE_TYPE_JSON_ID,
  FILE_TYPE_XML_ID,
  FILE_TYPE_CSV_ID,
];
export const FILE_TYPES_IMAGES = [FILE_TYPE_JPG_ID, FILE_TYPE_PNG_ID];
export const FILE_TYPES_TEXTUAL = [
  FILE_TYPE_JSON_ID,
  FILE_TYPE_XML_ID,
  FILE_TYPE_CSV_ID,
];
export const FILE_TYPES_ATTACHMENTS = [...FILE_TYPES_IMAGES, FILE_TYPE_PDF_ID];
